
import "../components/cart/Cart.css"
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";
import ProductDetail from "../components/product/ProductDetail";
import RelatedProducts from "../components/relatedProducts/RelatedProducts";
import { useEffect } from "react";


const Product=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    const products = [
        { id: 1, image: "images/menu-1.jpg", name: "Coffee Cappuccino", price: "$5.90" },
        { id: 2, image: "images/menu-2.jpg", name: "Coffee Cappuccino", price: "$5.90" },
        { id: 3, image: "images/menu-3.jpg", name: "Coffee Cappuccino", price: "$5.90" },
        { id: 4, image: "images/menu-4.jpg", name: "Coffee Cappuccino", price: "$5.90" }
      ];
    
    return(
        <div className="bg-imagea">
<Navbar/>
<Banner title="Product Details"/>
<ProductDetail/>
 {/* <RelatedProducts/>  */}
 <Footer/>
</div>
    )
}
export default Product;